module.exports = __webpack_public_path__ + "1798270ba5e7dc130458959dccc26b22.svg";